<template>
    <base-tabs
        :tabs="tabs"
        :height="'480px'"
    >
        <template slot-scope="{current}">
            <div
                class="body"
                v-if="current==='workorder'"
            >
                <div
                    v-if="workorders.length>0"
                    class="list"
                >
                    <a
                        v-for="(v,i) in workorders.slice(0,4)"
                        :key="v.id"
                        class="tab-body-item"
                        :href="v.url"
                        target="_blank"
                    >
                        <div
                            v-if="i !== 0"
                            class="hr"
                        ></div>

                        <div
                            class="tab-body-title"
                            :title="v.title"
                        >{{v.title}}</div>
                        <div class="tab-body-desc">
                            <span>提交于 {{v.createTime.format('YYYY-MM-DD')}}</span>

                            <span
                                v-if="v.status ==='wait'"
                                class="workorder-status"
                            >
                                <eco-icon
                                    name="time-filled"
                                    style="color:var(--warning-color)"
                                ></eco-icon>
                                已提交
                            </span>
                            <span
                                v-if="v.status ==='process'"
                                class="workorder-status"
                            >
                                <eco-icon
                                    name="ing"
                                    style="color:var(--action-color)"
                                ></eco-icon>
                                处理中
                            </span>
                            <span
                                v-if="v.status ==='resolved'"
                                class="workorder-status"
                            >
                                <eco-icon
                                    name="success-filled"
                                    style="color:var(--success-color)"
                                ></eco-icon>
                                待评价
                            </span>
                            <span
                                v-if="v.status ==='complete'"
                                class="workorder-status"
                            >
                                <eco-icon
                                    name="complete"
                                    style="color:#8C8C8C"
                                ></eco-icon>
                                已完成
                            </span>

                            <span
                                v-if="v.status ==='rejected'"
                                class="workorder-status"
                            >
                                <eco-icon
                                    name="revocation-filled"
                                    style="color:#8C8C8C"
                                ></eco-icon>
                                已撤回
                            </span>

                        </div>
                    </a>
                </div>
                <div
                    v-if="workorders.length>0"
                    class="extra"
                >
                    <div
                        style="margin-top:8px"
                        v-if="workorders.length>=4"
                    >
                        <a
                            href="/user-center/worksheet"
                            target="_blank"
                        >
                            <button class="btn-link  btn-link-arrow">查看更多</button>
                        </a>
                    </div>
                    <div style="margin-top:20px">
                        <a
                            class="blank-btn"
                            :href="can_create_worksheet?'/user-center/worksheet/new':'javascript:void(0)'"
                            :target="can_create_worksheet?'_blank':''"
                            style="display:block"
                        >
                            <button
                                style="height:36px;line-height:36px"
                                class="btn-block"
                                :class="{'btn-block':true,'disable':!can_create_worksheet}"
                            >
                                提工单
                            </button>
                        </a>
                    </div>
                </div>
                <div
                    class="blank"
                    v-else
                >
                    <div class="blank-image"></div>
                    <div class="blank-desc">暂无工单</div>
                    <a
                        class="blank-btn"
                        :href="can_create_worksheet?'/user-center/worksheet/new':'javascript:void(0)'"
                        :target="can_create_worksheet?'_blank':''"
                    >
                        <button :class="{'btn-block':true,'disable':!can_create_worksheet}">提工单</button>
                    </a>
                </div>
            </div>

            <div
                class="body"
                v-if="current==='question'"
            >
                <div
                    v-if="questions.length>0"
                    class="list"
                >
                    <a
                        v-for="(v,i) in questions.slice(0,4)"
                        :key="v.id"
                        class="tab-body-item"
                        :href="v.url"
                        target="_blank"
                    >
                        <div
                            v-if="i !== 0"
                            class="hr"
                        ></div>

                        <div
                            class="tab-body-title"
                            :title="v.title"
                        >{{v.title}}</div>

                        <div class="tab-body-desc">
                            <span>{{v.replyCount}} 回复</span>
                            <span class="hr-ver"></span>
                            <span>{{v.createTime.format('YYYY-MM-DD')}}</span>
                        </div>
                    </a>
                </div>
                <div
                    v-if="questions.length>0"
                    class="extra"
                >
                    <div
                        style="margin-top:8px"
                        v-if="questions.length>=4"
                    >
                        <a
                            href="/user-center/post"
                            target="_blank"
                        >
                            <button class="btn-link  btn-link-arrow">查看更多</button>
                        </a>
                    </div>
                    <div style="margin-top:20px">
                        <a
                            href="/community/question/"
                            target="_blank"
                            style="display:block"
                        >
                            <button
                                style="height:36px;line-height:36px"
                                class="btn-block"
                            >
                                去提问
                            </button>
                        </a>
                    </div>
                </div>
                <div
                    class="blank"
                    v-else
                >
                    <div class="blank-image"></div>
                    <div class="blank-desc">暂无问题</div>
                    <a
                        class="blank-btn"
                        href="/community/question/"
                        target="_blank"
                    >
                        <button class="btn-block">去提问</button>
                    </a>
                </div>
            </div>
        </template>
    </base-tabs>
</template>

<script>
import BaseTabs from "./BaseTabs.vue";
import { getQuestionList, getWorkorderList } from "../request/article";
import { user } from "eco-cli";

export default {
    components: { BaseTabs },
    data: () => ({
        tabs: [
            { title: "工单", key: "workorder" },
            { title: "问答", key: "question" },
        ],
        can_create_worksheet: true,
        workorders: [],
        questions: [],
    }),
    async beforeMount() {
        const permission = await user.getPermissions();
        this.can_create_worksheet = permission.isKeyOk(
            "client",
            "vip",
            "can_create_worksheet"
        );

        this.questions = await getQuestionList();
        this.workorders = await getWorkorderList();
    },
};
</script>

<style lang="scss" scoped>
.body {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 16px;

    .tab-body-item {
        padding: 16px 0;
        display: block;
        position: relative;

        &:hover .tab-body-title {
            color: var(--action-color);
        }

        .tab-body-title {
            font-size: var(--font-size-normal);
            line-height: var(--line-height-normal);
            color: var(--text-color-content);
            height: var(--line-height-normal);
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin-bottom: 4px;
        }

        .tab-body-desc {
            font-size: var(--font-size-small);
            line-height: var(--line-height-small);
            color: var(--text-color-desc);
        }

        .hr {
            height: 1px;
            width: 100%;
            position: absolute;
            top: 0;
            background: var(--hr-color-hor);
        }
    }
}

.list {
    flex: auto;
}

.extra {
    flex: 0;
    margin-bottom: 16px;
}
.workorder-status {
    float: right;
}
.blank {
    .blank-image {
        height: 160px;
        width: 160px;
        background-size: cover;
        background-image: url("../assets/blank.png");
        margin: 72px auto 8px auto;
    }
    .blank-desc {
        text-align: center;
        color: var(--text-color-desc);
        margin-bottom: 24px;
    }
    .blank-btn {
        display: block;
        width: 128px;
        margin: 0 auto;
        > button {
            line-height: 36px;
        }
    }
}

.hr-ver {
    display: inline-block;
    height: 12px;
    margin: 4px 8px;
    width: 1px;
    vertical-align: bottom;

    background: var(--hr-color-ver);
}
.btn-block.disable {
    background: var(--action-color-disable);
    cursor: not-allowed;
}
</style>